import { ArtistRiderFilePanel } from "components/FileUpload/SingleFilePanel";
import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import { RenderEditOptions } from "components/MainSectionTemplate/types";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import React, { useState } from "react";

interface ArtistRiderDetailSectionProps {
  artistRider: server.dto.ArtistRider
}

export const ArtistRiderDetailSection = (props: ArtistRiderDetailSectionProps) => {
  const [title, setTitle] = useState<string>(props.artistRider.title);

  return <DetailSectionTemplate
    isInPageEditable
    onValueChanged={(_: string, value: any) => setTitle(value)}
    sections={[{
      type: "regular",
      key: "artistRider",
      title: RESX.ArtistRider.resxArtistRider,
      fields: [{
        key: "title",
        label: RESX.GeneralLabels.Title,
        render: () => <div>{title}</div>,
        inPageEdit: {
          render: ({ value, onChange, submit, cancel }: RenderEditOptions<string>) => <RequiredTextInput
            validatorKey="title"
            focusOnMount
            maxLength={serverReference.constants.wordTemplate.maxTitleLength}
            value={value}
            onChange={(t) => { onChange(t); }}
            onEnter={() => submit()}
            onEsc={() => cancel()}
          />,
          fullWidth: true,
          type: "confirmOrCancelButton",
          initialValue: title,
          submitChange: (title: string) => window.CoreApi.ArtistRider.Update({
            artistRiderId: props.artistRider.artistRiderId,
            title,
          }),
        },
      }]
    }, {
      key: "file",
      type: "custom",
      render: () => <ArtistRiderFilePanel
        key="files-panel"
        title={title}
        artistRiderId={props.artistRider.artistRiderId}
        onUploadComplete={() => { }}
      />
    }]}
  />
}